export default __webpack_public_path__ + "55bf27419c4a93421e30015fc442b37d.svg";